import React from 'react';
import { useTranslation } from 'react-i18next';
import './P1.css';
import Section from './Section';
import img2 from '../../Assets/img2.png';
import img6 from '../../Assets/img6.png';
import img3 from '../../Assets/img3.png';
import img1 from '../../Assets/img1.png';
import img5 from '../../Assets/img5.png';
import img4 from '../../Assets/img4.png';

const P1 = () => {
  const { t } = useTranslation('partnership');
  
  return (
    <div className="partners-content">
      <h1 className="page-title">{t('title')}</h1>
      
      <div className="partners-sections">
        <Section
          imageSrc={img2}
          title="8D Games  Netherlands"
          description={t('partner1')}
        />
        <Section
          imageSrc={img6}
          title="Aproximar  Portugal"
          description={t('partner2')}
        />
        <Section
          imageSrc={img3}
          title="CRN  Germany"
          description={t('partner3')}
        />
        <Section
          imageSrc={img1}
          title="Magnetar  Cyprus"
          description={t('partner4')}
        />
        <Section
          imageSrc={img5}
          title="OECON  Greece"
          description={t('partner5')}
        />
        <Section
          imageSrc={img4}
          title="Technical University of Košice   Slovakia"
          description={t('partner6')}
        />
      </div>
    </div>
  );
};

export default P1;